import React from 'react';
import { hot } from 'react-hot-loader';
import Slider from '../../../hocs/Slider/Slider';
import { translate } from '../../../utils/locale';
import s from './Instagram.scss';

const Instagram = ({ content, setup }) => {
	if (!content?.individual?.posts) return null;
	let Wrapper = ({ children }) => children;

	if (content.individual.posts.length > parseInt(content.amount, 10)) {
		const sliderAttrs = {
			showArrows: false,
			autoplay: 4000,
			autoplayFilm: false,
			screenMinWidthDisable: 750,
		};
		Wrapper = ({ children }) => <Slider infinite {...sliderAttrs}>{ children }</Slider>;
	}

	const groupSlides = [];

	const playFilm = (e) => {
		if (e.target.closest('svg')) {
			e.preventDefault();
			const videosInGroup = e.currentTarget.parentElement.querySelectorAll('video');
			if (videosInGroup.length > 1) {
				[...videosInGroup].forEach((v) => {
					v.pause();
				});
			}
			e.currentTarget.querySelector('video').play();
		}
	};

	content.individual.posts.forEach((insta, i) => {
		const currentGroup = Math.floor(i / content.amount);
		if (!groupSlides[currentGroup]) groupSlides[currentGroup] = [];
		groupSlides[currentGroup].push((
			<a key={insta.instagramId} id={insta.instagramId} className={[s.instagram_item, (insta.localFilm ? s.instagram_item__film : null)].join(' ')} href={insta.instagramLink} rel="noopener noreferrer nofollow" target="_blank" onClick={playFilm}>
				{
					insta.localFilm ? (
						<>
							<video className={s.instagram_item_image} src={insta.localFilm.url} muted playsInline loop />
							<svg className={s.instagram_item_playIcon} aria-label="Video" color="#ffffff" fill="#ffffff" height="18" role="img" viewBox="0 0 24 24" width="18"><path d="M5.888 22.5a3.46 3.46 0 01-1.721-.46l-.003-.002a3.451 3.451 0 01-1.72-2.982V4.943a3.445 3.445 0 015.163-2.987l12.226 7.059a3.444 3.444 0 01-.001 5.967l-12.22 7.056a3.462 3.462 0 01-1.724.462z" /></svg>
						</>
					) : (
						<img className={s.instagram_item_image} src={insta.instagramThumbnail} alt="" />
					)
				}
			</a>
		));
	});

	return (
		<div className={[s.instagram, s[`instagram__${content.amount}`]].join(' ')}>
			<img className={s.instagram_banner} src="https://images.marsblade.com/uploads/2021/12/instagram_gradientbanner_2000x50px.png" alt="" width="2000" height="20" />
			<div className={s.instagram_menu}>
				<img className={s.instagram_menu_left} src="https://images.marsblade.com/uploads/2021/12/instagram_combined_logo.svg" alt="" width="143" height="40" />
				<a className={s.instagram_menu_right} href="https://www.instagram.com/marsblade/" rel="noopener noreferrer nofollow" target="_blank">
					<img className={s.instagram_menu_right_badge} src="https://images.marsblade.com/uploads/2021/12/instagram_profileicon_211125.svg" alt="" width="45" height="45" />
					<div className={s.instagram_menu_right_followers}>
						<span>marsblade</span>
						<span>{ translate(setup, content.followersCount) }</span>
					</div>
					<span className={s.instagram_menu_right_viewProfile}>{ translate(setup, content.viewProfile) }</span>
				</a>
			</div>
			<div className={s.instagram_content}>
				<Wrapper>
					{
						groupSlides.map((group) => (
							<div key={group.map((g) => g.key).join(',')} className={s.instagram_items}>
								{ group }
							</div>
						))
					}
				</Wrapper>
			</div>
			<div className={s.instagram_viewMore}>
				<a className={s.instagram_viewMore_link} href="https://www.instagram.com/marsblade/" rel="noopener noreferrer nofollow" target="_blank">{ translate(setup, content.viewMore) }</a>
			</div>
		</div>
	);
};

export default hot(module)(Instagram);
